import { memo } from "react";
import { Card, CardContent, CardHeader, Grid2, IconButton, Skeleton, Typography } from "@mui/material";
import { icon } from "@/app/style/icons";
import { FETCH_USER_PROFILE } from "@company/graphql/queries/fetchUserProfile";
import { Query, User } from "@/app/graphql/codegen";
import { useQuery } from "@apollo/client";
import { FETCH_COMPANY } from "@company/graphql/queries/fetchCompany";
import { useUserProfile } from "@company/hooks/useUserProfile";
import { useCompanyProfile } from "@company/hooks/useCompanyProfile";

const ProfileWidget = memo(() => {
    const { user } = useUserProfile();
    const { company } = useCompanyProfile();

    return (
        <Card sx={{ width: "100%", height: "100%", p: 1.5, pb: 0 }}>
            <CardHeader avatar={<Skeleton variant={"circular"} width={52} height={52} />} title={user?.name} />

            <CardContent>
                <Grid2 container size={12} spacing={0} direction={"column"}>
                    <Grid2 container size={12} alignItems={"center"} spacing={0.5}>
                        <Grid2 mt={-0.2}>
                            <IconButton>
                                <icon.company sx={{ fontSize: 20, opacity: 0.75, color: "semantic.icon.informative" }} />
                            </IconButton>
                        </Grid2>

                        <Grid2>
                            <Typography>{company?.name}</Typography>
                        </Grid2>
                    </Grid2>

                    <Grid2 container size={12} alignItems={"center"} spacing={0.5}>
                        <Grid2>
                            <IconButton>
                                <icon.work sx={{ fontSize: 19, opacity: 0.75, color: "semantic.icon.informative" }} />
                            </IconButton>
                        </Grid2>

                        <Grid2>
                            <Typography>{user?.title}</Typography>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    );
});

export default ProfileWidget;
